import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const steps = [{
  n: '1',
  title: 'Get your Reader-to-Revenue Score',
  lines: ['8 questions to see how clearly reader interest connects to your business.']
}, {
  n: '2',
  title: 'Audit the reader path',
  lines: ['A deeper look at whether the path is worth building.']
}, {
  n: '3',
  title: 'Decide whether to build',
  lines: ['No pressure.', 'Decide once the opportunity is clear.']
}];
export function ScoreAuditBuild() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paperDark" width="default" data-id="element-965" data-mp="2hc3jia9ukvwb">
      <div className="mx-auto max-w-2xl text-center" data-id="element-966" data-mp="2cfmtfaj387gl">
        <Reveal data-id="element-967" data-mp="2cgxz5fw3fpac">
          <Eyebrow data-id="element-968" data-mp="15yrkqdsy33h0">How it works</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-969" data-mp="15zsywr59c62y">
            Get the score before you
            <br data-id="element-970" data-mp="10ydaqq7s9jgc" />
            <span className="italic text-seaglass" data-id="element-971" data-mp="11214nqh547vl">decide what to build.</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} data-id="element-972" data-mp="1cibx9y9oo6ms">
        <div className="mt-14 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-973" data-mp="1chka9bu5jh84">
          {steps.map(step => <div key={step.n} className="relative rounded-3xl border border-gray-200 bg-white p-7 text-center" data-id="element-974" data-mp="yjlv4480bgrk">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-seaglass font-serif text-xl text-white" data-id="element-975" data-mp="13gudo5x2hmtc">
                {step.n}
              </div>
              <h3 className="mt-5 font-serif text-xl text-navy" data-id="element-976" data-mp="tjzjfz7tu8kv">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-text-muted" data-id="element-977" data-mp="fsl1lvpnodfe">
                {step.lines.map(line => <span key={line} className="block" data-id="element-978" data-mp="kr5ypm9m2gzm">
                    {line}
                  </span>)}
              </p>
            </div>)}
        </div>
      </Reveal>

      <Reveal delay={0.15} data-id="element-979" data-mp="5w86ctegprij">
        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-980" data-mp="asymthu6ip4h">
          <Cta variant="primary" showArrow onClick={openDiagnostic} className="px-10 py-4 text-lg" data-id="element-981" data-mp="avcerhtkbl7t">
            Get Your Reader-to-Revenue Score
          </Cta>
          <p className="text-center text-base font-medium text-text-muted" data-id="element-982" data-mp="3j29a5md8s888">
            <span className="block" data-id="element-983" data-mp="3e3ocnupdk2nh">Start with the Score.</span>
            <span className="block" data-id="element-984" data-mp="3e23cnpkajri8">The rest follows only if it fits.</span>
          </p>
        </div>
      </Reveal>
    </SectionBand>;
}